import { Component, Prop, Vue } from 'vue-property-decorator';
import RequestButtonBack from '@/components/request/RequestButtonBack/RequestButtonBack.vue';
import RequestDetail from '@/components/request/RequestDetail/RequestDetail.vue';

@Component<RequestTab>({
  components: {
    'request-detail': RequestDetail,
  }
})
export default class RequestTab extends Vue {
  @Prop()
  private requestId!: string;

  private mounted(): void {
    console.log(`RequestTab Mounted with id: ${this.$route.params.id}`);
  }
}
